import InsightsIcon from '@mui/icons-material/Insights';

const icons = {
    InsightsIcon
};

const IntimationMisTracker = {
    id: 'intimation-mis',
    type: 'group',
    children: [
        {
            id: 'intimation-mis-tracker',
            title: 'Intimation MIS Tracker',
            type: 'item',
            url: '/Intimation-MIS-Tracker',
            icon: icons.InsightsIcon,
        }
    ]
};

export default IntimationMisTracker
